/**
 * Public Firebase Web SDK config for the PinStaQ Admin Portal.
 *
 * Mirrors the pattern used by `lib/firebase_options.dart` (Flutter, committed)
 * and `hosting/public/assets/js/app-check-init.js` (marketing site, committed).
 *
 * These values are NOT secrets — they identify the Firebase project to the
 * browser and are visible in any built client bundle. Security is enforced by:
 *   - Firebase Auth Authorized Domains (admin.pinstaq.com / admin-staging.pinstaq.com)
 *   - Firestore Security Rules (`isAdmin()` gate)
 *   - App Check + reCAPTCHA Enterprise (when enabled)
 *   - Custom claim `role == "platform_admin"` checked in callable Cloud Functions
 *
 * If you ever rotate the keys (e.g. after a project migration), update this
 * file and re-deploy. No CI secret rotation needed.
 */

export interface AdminFirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  appId: string;
  messagingSenderId: string;
  storageBucket: string;
  /** reCAPTCHA Enterprise site key for App Check. Empty string disables App Check init. */
  recaptchaSiteKey: string;
  /** Cloud Functions region (callable + HTTP). */
  functionsRegion: string;
}

/**
 * Same Firebase project as the rest of PinStaQ (`pinstaq-app`).
 * Reuses the marketing site's web app registration — works for App Check today.
 * Replace with a dedicated `pinstaq-admin` Firebase web app whenever it's registered.
 */
export const ADMIN_FIREBASE_CONFIG: AdminFirebaseConfig = {
  apiKey: "AIzaSyDy3Y3MxqznRm_ETtEONYCKG-R2uw8C_fU",
  authDomain: "pinstaq-app.firebaseapp.com",
  projectId: "pinstaq-app",
  appId: "1:1051301934422:web:e6e4832ff663833d00d2f7",
  messagingSenderId: "1051301934422",
  storageBucket: "pinstaq-app-storage",
  // Marketing's reCAPTCHA Enterprise site key (the App Check registration is
  // the Enterprise config — use ReCaptchaEnterpriseProvider). Allowed domains in reCAPTCHA admin
  // console must include admin.pinstaq.com + admin-staging.pinstaq.com before
  // App Check tokens will issue on those hosts.
  recaptchaSiteKey: "6Lf-7IMsAAAAABVuFGrLEJ5lZED0ZWduEH2Bnfy1",
  functionsRegion: "europe-west2",
};
